import React, { useState, useEffect } from 'react';

import { useFreecodeContextData, useFreecodeContextLayout } from 'hooks/useContext';
import { identifiers, layouts } from './FreecodeLayoutConstants';
import { Spinner } from 'components/Spinner/Spinner';
import FreecodeLayoutDefault from './FreecodeLayoutDefault';
import FreecodeLayoutWide from './FreecodeLayoutWide';
import FreecodeLayoutSmall from './FreecodeLayoutSmall';
import FreecodeCanvas from 'components/FreecodePage/FreecodeTabs/FreecodeCanvas/FreecodeCanvas';
import FreecodeConsoleAndScore from 'components/FreecodePage/FreecodeTabs/FreecodeConsoleAndScore/FreecodeConsoleAndScore';
import FreecodeDescription from 'components/FreecodePage/FreecodeTabs/FreecodeDescription/FreecodeDescription';
import FreecodeApi from 'components/FreecodePage/FreecodeTabs/FreecodeApi/FreecodeApi';
import FreecodeEditorSolution from 'components/FreecodePage/FreecodeTabs/FreecodeCodeEditor/FreecodeEditorSolution';

/**
 * Manage components for freecode editor.
 */
export default function FreecodeLayout({ parentComponents }) {
  const { layout } = useFreecodeContextLayout();
  const { testImpl } = useFreecodeContextData();

  const [componentMap, setComponentMap] = useState();

  useEffect(() => {
    if (!testImpl) return;
    setComponentMap((oldState) => {
      let newComponentMap = { ...(parentComponents || {}), ...(oldState || {}) };

      if (!newComponentMap[identifiers.solution]) newComponentMap[identifiers.solution] = <FreecodeEditorSolution />;
      if (!newComponentMap[identifiers.console]) newComponentMap[identifiers.console] = <FreecodeConsoleAndScore />;
      if (!newComponentMap[identifiers.description]) newComponentMap[identifiers.description] = <FreecodeDescription />;

      if (testImpl.api?.challenge?.length) {
        if (!newComponentMap[identifiers.api]) newComponentMap[identifiers.api] = <FreecodeApi />;
      } else if (newComponentMap[identifiers.api]) {
        delete newComponentMap[identifiers.api];
      }

      if (testImpl.configCanvas?.canvasUsed) {
        if (!newComponentMap[identifiers.canvas]) newComponentMap[identifiers.canvas] = <FreecodeCanvas />;
      } else if (newComponentMap[identifiers.canvas]) delete newComponentMap[identifiers.canvas];

      if (!testImpl.isFlow && newComponentMap[identifiers.flow]) delete newComponentMap[identifiers.flow];
      if (!testImpl?.enableSkeletonEditing && newComponentMap[identifiers.enableSkeletonEditing])
        delete newComponentMap[identifiers.enableSkeletonEditing];

      return newComponentMap;
    });
  }, [testImpl, parentComponents]);

  const result = {
    [layouts.spinner]: <Spinner />,
    [layouts.small]: <FreecodeLayoutSmall componentMap={componentMap} />,
    [layouts.default]: <FreecodeLayoutDefault componentMap={componentMap} />,
    [layouts.wide]: <FreecodeLayoutWide componentMap={componentMap} />,
  };

  return componentMap && result[layout];
}
